import { Component, TemplateRef, ViewChild, AfterViewInit } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';


@Component({
    selector: 'formly-wrapper-addons',
    template: `
    <ng-template *ngIf="to.addonLeft" #matPrefix>
    <span
        [ngStyle]="{cursor: to.addonLeft.onClick ? 'pointer' : 'inherit'}"
        (click)="addonLeftClick($event)"
    >
        <i *ngIf="to.addonLeft.class" [ngClass]="to.addonLeft.class"></i>&nbsp;
        <span *ngIf="to.addonLeft.text">{{ to.addonLeft.text }}</span>&nbsp;
    </span>
    </ng-template>

    <ng-container #fieldComponent></ng-container>

    <ng-template *ngIf="to.helpText" #matSuffix>
    <span
      class="tw-mr-2"
        [matTooltip]="to.helpText"
        [matTooltipPosition]="positionValue"
    >
        <mat-icon matIconSuffix color="primary">info_outline</mat-icon>
    </span>
    </ng-template>
  `,
  standalone: false
})
export class FormlyWrapperAddonsComponent extends FieldWrapper implements AfterViewInit {
    @ViewChild('matPrefix') matPrefix: TemplateRef<any>;
    @ViewChild('matSuffix') matSuffix: TemplateRef<any>;

    positionValue = 'above';


    ngAfterViewInit() {
        if (this.matPrefix) {
            Promise.resolve().then(() => this.to.prefix = this.matPrefix);
        }

        if (this.matSuffix) {
            Promise.resolve().then(() => this.to.suffix = this.matSuffix);
        }
    }
}


/**  Copyright 2018 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */
